import { COUNTRIES } from '../GscTools/countries';

/**
 * The three surfaces this report reads, named by the Search Console `type` each one is.
 *
 * They are three different products that happen to share a word. Discover is the feed on the
 * Google app and the mobile homepage; Google News is news.google.com and the Google News apps; the
 * News tab is a filter inside Google Search itself. A click on one is not a click on another, so
 * the report reads exactly one at a time and never adds them up — a total across them would be a
 * number with no surface behind it.
 *
 * They are kept as the API's own strings because every request and every exported row has to name
 * the surface exactly as Search Console does.
 */
export const SOURCE = {
    DISCOVER: 'discover',
    GOOGLE_NEWS: 'googleNews',
    NEWS_TAB: 'news',
};

export const SOURCES = [SOURCE.DISCOVER, SOURCE.GOOGLE_NEWS, SOURCE.NEWS_TAB];

export const DEFAULT_SOURCE = SOURCE.DISCOVER;

export function isSource(value) {
    return SOURCES.includes(value);
}

/** The label for a source, from the shared search-type strings so every GSC tool names it alike. */
export function sourceLabel(t, source) {
    return t(`tools.gsc.search_types.${source}`);
}

/** What each surface actually covers, in a sentence, for the summary and the coverage block. */
export function sourceScope(t, source) {
    return t(`tools.discover_news.sources.${source}`);
}

const COUNTRY_NAMES = new Map(COUNTRIES.map((country) => [country.value, country.label]));

/**
 * The readable name for a returned country key, or the key itself when there is none.
 *
 * Only the display changes. The key Search Console returned is what the filter is built from and
 * what the export carries, so a row relabelled "United States" still filters on `usa`.
 */
export function countryLabel(key) {
    if (!key) return '';
    return COUNTRY_NAMES.get(key.toLowerCase()) ?? key;
}
